import { useTranslation } from 'react-i18next';
import { teamMembers } from '@/mocks/landingData';

export default function TeamSection() {
  const { t } = useTranslation();

  return (
    <section id="team" className="relative w-full py-20 md:py-32 bg-dark-800">
      <div className="w-full px-4 md:px-6 lg:px-12">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-display font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white">
            {t('team.title1')}{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-blue to-neon-purple">
              {t('team.title2')}
            </span>
          </h2>
          <p className="mt-4 text-sm md:text-base text-gray-400 max-w-xl mx-auto">
            {t('team.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 max-w-2xl mx-auto">
          {teamMembers.map((member) => (
            <div
              key={member.id}
              className="group p-5 md:p-6 rounded-2xl bg-dark-500 border border-white/5 hover:border-neon-blue/20 transition-all duration-500 text-center"
            >
              <div className="relative w-32 h-40 md:w-36 md:h-44 mx-auto mb-4 rounded-xl overflow-hidden border-2 border-neon-blue/20 group-hover:border-neon-blue/50 transition-all duration-500 shadow-[0_0_20px_rgba(0,217,255,0.05)] group-hover:shadow-[0_0_30px_rgba(0,217,255,0.15)]">
                <img
                  src={member.image}
                  alt={`${member.name} - ${member.role}`}
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-[1.04]"
                />
              </div>
              <h3 className="text-base md:text-lg font-display font-bold text-white mb-1">
                {t(`team.${member.id}`)}
              </h3>
              <p className="text-xs text-neon-blue mb-1">
                {t('team.nickname')}: {member.nickname}
              </p>
              <p className="text-xs md:text-sm text-gray-400 mb-4">{t(`team.role_${member.id}`)}</p>
              <div className="flex justify-center gap-2">
                {member.socials.map((social) => (
                  <a
                    key={social.type}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-8 h-8 rounded-lg bg-dark-400 flex items-center justify-center text-gray-500 hover:text-neon-blue hover:bg-neon-blue/10 transition-all duration-300 cursor-pointer"
                  >
                    <i
                      className={
                        social.type === 'github'
                          ? 'ri-github-fill text-sm'
                          : social.type === 'linkedin'
                            ? 'ri-linkedin-fill text-sm'
                            : social.type === 'telegram'
                              ? 'ri-telegram-fill text-sm'
                              : 'ri-global-line text-sm'
                      }
                    />
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
